import { render, staticRenderFns } from "./FullList.vue?vue&type=template&id=50d794c8&scoped=true"
import script from "./FullList.vue?vue&type=script&lang=js"
export * from "./FullList.vue?vue&type=script&lang=js"
import style0 from "./FullList.vue?vue&type=style&index=0&id=50d794c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d794c8",
  null
  
)

export default component.exports